<script lang="ts">
import { defineComponent, reactive } from "vue";
import { useAuthStore } from "../../Authentication/stores/useAuthStore";
import { useNotificationSearchStore } from "./stores/useNotificationSearchStore";
import { useInfiniteScroll } from "@vueuse/core";
import _ from "lodash";

export default defineComponent({
  name: "NotificationView",
  components: {},
  data() {
    return {
      componentName: this.$options.name,
      results: null as any,
      isLoading: false,
    };
  },
  computed: {
    components() {
      return {};
    },
  },
  methods: {
    async newsFetch() {
      if (!this.loading()) {
        this.notificationSearchStore.currentPage = this.notificationSearchStore.currentPage + 1;

        let results = await this.notificationSearchStore.onUpdateCurrentPage(this.notificationSearchStore.currentPage);

        if (!this.notificationSearchStore.tableScrollResults) {
          this.notificationSearchStore.tableResults = results;
          this.notificationSearchStore.tableScrollResults = _.cloneDeep(results);
          this.notificationSearchStore.totalPage = results?.totalPages;
        } else {
          this.notificationSearchStore.tableResults.items.push(...results?.items);
          this.notificationSearchStore.tableResults.totalPage = this.notificationSearchStore.tableResults.totalPages;
          results = this.notificationSearchStore.tableResults;
        }
        this.notificationSearchStore.tableScrollResults.items = results.items;
        this.notificationSearchStore.actionStatus = this.$enums.ENUM_MUTATION_STATUS.SUCCESS;
        this.notificationSearchStore.loading = false;
      }
    },
    async newsScrollFetch() {
      useInfiniteScroll(
        this.el,
        () => {
          if (this.notificationSearchStore.totalPage > this.notificationSearchStore.currentPage) this.newsFetch();
        },
        { distance: 10 }
      );
      // return stop;
    },
    loading() {
      return this.notificationSearchStore.loading;
    },
    async reset() {
      await this.notificationSearchStore.$reset();
    },
    async setting() {
      await this.newsFetch();
      await this.newsScrollFetch();
    },
  },
  async mounted() {
    await this.reset();
    await this.setting();
  },
  async unmounted() {
    await this.reset();
  },
  setup() {
    const authStore = useAuthStore();
    const notificationSearchStore = useNotificationSearchStore();

    var state = reactive({
      el: null,
    });

    return {
      authStore,
      notificationSearchStore,
      el: state.el,
      state,
    };
  },
});
</script>

<template>
  <div id="page-container" class="flex flex-col mx-auto w-full min-w-[320px]">
    <main class="flex max-w-full flex-auto flex-col">
      <div class="mx-auto flex w-full max-w-10xl justify-center">
        <div class="flex flex-col w-full max-w-5xl h-screen">
          <div class="flex items-center justify-center mx-2 my-5">
            <div class="w-10 text-white text-left">
              <button
                @click="
                  () => {
                    $router.go(-1);
                  }
                "
              >
                <component :is="$solidIcons.ChevronLeftIcon" class="flex-none inline-block ttp-icon-inside-box-02" />
              </button>
            </div>
            <div class="w-full text-white font-bold text-center">
              <h1 class="ttp-text-xl">Notification</h1>
            </div>
            <div v-if="false" class="w-10 text-white text-right">
              <div class="absolute right-0 origin-bottom-right z-10 mt-10 shadow-md rounded-lg focus:outline-none">
                <div class="text-center bg-white ring-1 ring-black ring-opacity-5 rounded-lg divide-y divide-gray-100">
                  <div class="text-black cursor-pointer p-4 rounded-lg hover:bg-[#EDF3FF]">Mark all as read</div>
                  <div class="text-black cursor-pointer p-4 rounded-lg hover:bg-[#EDF3FF]">Delete all</div>
                </div>
              </div>
              <button @click="() => {}">
                <component :is="$solidIcons.EllipsisVerticalIcon" class="flex-none inline-block ttp-icon-inside-box-02 mx-1" />
              </button>
            </div>
          </div>
          <div ref="el" class="flex flex-col items-center justify-center gradient-border px-0 pt-0 pb-0 mb-4 h-full overflow-auto">
            <div v-if="notificationSearchStore?.tableResults?.items?.length" class="flex flex-col w-full h-full overflow-auto pb-12 md:pb-0">
              <template v-for="(result, _index) in notificationSearchStore?.tableScrollResults?.items" :key="_index">
                <router-link :to="{ name: result?.data?.view, params: { id: JSON.parse(result?.data?.params)?.id } }" class="flex w-full gap-4 p-4 border-b border-stone-300">
                  <div>
                    <div class="inline-flex ttp-icon-box-01 items-center justify-center rounded-full bg-gray-100 text-gray-300 dark:bg-gray-700 dark:text-gray-500">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2C3483" class="ttp-icon-inside-box-02">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
                      </svg>
                    </div>
                  </div>
                  <div class="flex flex-col gap-1 w-full justify-center">
                    <div class="text-black ttp-text-xl font-medium">{{ $convertString(result?.title) }}</div>

                    <div class="text-black ttp-text-sm" v-html="$convertString(result?.body)"></div>
                    <small>{{ $dayjs(result?.createdAt).format("DD/MM/YYYY HH:mm") }}</small>
                  </div>
                </router-link>
              </template>
            </div>
            <div v-else-if="!notificationSearchStore?.tableResults?.items?.length && notificationSearchStore.currentPage == 1 && !notificationSearchStore.loading" class="flex flex-col w-full gap-2 items-center justify-center">
              <svg class="ttp-icon-inside-box-05" viewBox="0 0 156 165" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1_18180)">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M14 154.747C14 155.757 13.6 156.675 12.95 157.349C12.9207 157.385 12.8883 157.417 12.853 157.446C12.147 158.134 11.1987 158.516 10.2134 158.509C9.22802 158.502 8.2849 158.108 7.58815 157.411C6.89139 156.715 6.49705 155.771 6.49047 154.786C6.48389 153.801 6.86561 152.852 7.553 152.146C7.5823 152.111 7.61477 152.078 7.65 152.048C8.17948 151.538 8.84754 151.194 9.57094 151.06C10.2943 150.927 11.0411 151.009 11.7181 151.297C12.3951 151.584 12.9725 152.065 13.3783 152.679C13.7841 153.292 14.0003 154.012 14 154.747ZM10.252 152.499C10.6319 152.499 11.0057 152.595 11.3384 152.779C11.6711 152.962 11.952 153.227 12.1547 153.548C12.3574 153.869 12.4754 154.236 12.4977 154.616C12.52 154.995 12.4458 155.374 12.282 155.716L9.282 152.718C9.58484 152.574 9.91634 152.499 10.252 152.499ZM8.222 153.779L11.22 156.777C10.8004 156.978 10.3289 157.044 9.87047 156.965C9.41203 156.887 8.98923 156.668 8.66034 156.339C8.33145 156.01 8.11268 155.587 8.03417 155.129C7.95566 154.671 8.02129 154.199 8.222 153.779ZM10.252 159.746C10.359 159.746 10.466 159.742 10.572 159.736V160.574C10.572 160.808 10.672 161.04 10.861 161.216C11.08 161.42 11.252 161.499 11.5 161.499C11.6326 161.499 11.7598 161.552 11.8536 161.646C11.9473 161.74 12 161.867 12 161.999C12 162.132 11.9473 162.259 11.8536 162.353C11.7598 162.447 11.6326 162.499 11.5 162.499H0.5C0.367392 162.499 0.240215 162.447 0.146447 162.353C0.0526784 162.259 0 162.132 0 161.999C0 161.867 0.0526784 161.74 0.146447 161.646C0.240215 161.552 0.367392 161.499 0.5 161.499C0.748 161.499 0.92 161.42 1.14 161.216C1.22968 161.135 1.30156 161.036 1.35113 160.926C1.40069 160.815 1.42686 160.696 1.428 160.574V156.799C1.428 155.647 1.918 154.549 2.779 153.747C3.60147 152.99 4.66659 152.549 5.784 152.504C5.40108 153.267 5.21954 154.114 5.25666 154.966C5.29378 155.818 5.54832 156.646 5.99606 157.372C6.4438 158.098 7.06985 158.697 7.81462 159.113C8.5594 159.529 9.39913 159.747 10.252 159.746ZM4.25 164.249C4.25 164.051 4.32902 163.86 4.46967 163.719C4.61032 163.578 4.80109 163.499 5 163.499H7C7.19891 163.499 7.38968 163.578 7.53033 163.719C7.67098 163.86 7.75 164.051 7.75 164.249C7.75 164.448 7.67098 164.639 7.53033 164.78C7.38968 164.92 7.19891 164.999 7 164.999H5C4.80109 164.999 4.61032 164.92 4.46967 164.78C4.32902 164.639 4.25 164.448 4.25 164.249Z" fill="white" />
                </g>
                <path d="M81 150C122.421 150 156 116.421 156 75C156 33.5786 122.421 0 81 0C39.5786 0 6 33.5786 6 75C6 116.421 39.5786 150 81 150Z" fill="#E1EBFC" />
                <path d="M125.25 109.417V114.334H36.7499V109.417L46.5833 99.584V70.084C46.5833 54.8423 56.5641 41.4198 71.1666 37.0932V35.6673C71.1666 33.0594 72.2026 30.5582 74.0467 28.7141C75.8908 26.87 78.392 25.834 80.9999 25.834C83.6079 25.834 86.109 26.87 87.9531 28.7141C89.7973 30.5582 90.8333 33.0594 90.8333 35.6673V37.0932C105.436 41.4198 115.417 54.8423 115.417 70.084V99.584L125.25 109.417Z" fill="white" />
                <path d="M90.8333 119.251C90.8333 121.859 89.7973 124.36 87.9531 126.204C86.109 128.048 83.6079 129.084 80.9999 129.084C78.392 129.084 75.8908 128.048 74.0467 126.204C72.2026 124.36 71.1666 121.859 71.1666 119.251H90.8333Z" fill="white" />
                <path d="M119.104 31.6848L112.122 38.6665C116.281 42.774 119.582 47.6661 121.836 53.0592C124.089 58.4522 125.25 64.239 125.25 70.084H135.083C135.083 55.6782 129.38 41.8132 119.104 31.6848Z" fill="white" />
                <path d="M26.9166 70.084H36.7499C36.7499 58.284 41.4699 46.9757 49.8774 38.6665L42.8958 31.6848C37.8212 36.7075 33.7954 42.6887 31.0522 49.2806C28.3091 55.8726 26.9033 62.944 26.9166 70.084Z" fill="white" />
                <defs>
                  <clipPath id="clip0_1_18180">
                    <rect width="14" height="14" fill="white" transform="translate(0 151)" />
                  </clipPath>
                </defs>
              </svg>

              <div class="text-[#D3D3D3] ttp-text-xl font-bold">{{ $t("layout.not_found") }}</div>
              <div class="text-[#D3D3D3] ttp-text-sm">{{ $t("page.HistoryDetailPoliceTouristAndAgentView.not_found_detail") }}</div>
            </div>
            <div v-if="loading()" class="flex flex-col justify-center items-center w-full">
              <div><LoadingFormComponent /></div>
              <div class="ttp-text-xs">{{ $t("layout.loading") }}</div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
